import * as yup from 'yup';
import {
  CloudinaryImage,
  CollectionPiece,
  MarketPlaceListing,
  SignupAndArtistWaitlistFormValues,
  VariantRequest,
} from '../interfaces';

export const phoneRegExp =
  /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;

export const processEditFormMediaFiles = (
  collectionTypeWithMedia:
    | CollectionPiece
    | MarketPlaceListing
    | VariantRequest,
  media: CloudinaryImage[] | File[],
  data: any,
  formData: FormData
) => {
  const newMediaFilesAdded = media.some((f: any) => f.path);
  const oneOrMoreExistingMediaFilesRemoved =
    collectionTypeWithMedia?.media?.length &&
    media.length !== collectionTypeWithMedia.media.length;
  const noMediaFilesAndNoExistingFiles =
    media.length === 0 && !collectionTypeWithMedia.media;
  if (newMediaFilesAdded) {
    for (const file of media) {
      formData.append('files.media', file as File, file.name);
    }
  } else if (noMediaFilesAndNoExistingFiles) {
    data.media = null;
  } else if (oneOrMoreExistingMediaFilesRemoved) {
    data.media = (media as CloudinaryImage[]).map((v: CloudinaryImage) => v.id);
  }
  return { ...data };
};

export const LoginSchema = yup.object({
  identifier: yup.string().email().required('Please provide a valid email'),
  password: yup.string().required('Password is required'),
});

export const LoginFormInitialValues = {
  identifier: '',
  password: '',
};

export const initialSignupFormValues: SignupAndArtistWaitlistFormValues = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  passwordConfirmation: '',
  phoneNumber: '',
  city: '',
  tcAgree: false,
  updatesAgree: false,
  smsOptedIn: false,
  prints: false,
  collectibles: false,
  stickers: false,
  sculptures: false,
  sculpture_budget: 0,
  painting_budget: 0,
  paintings: false,
  nft: false,
  apparel: false,
  artist: -1,
  author: -1,
};

export const EventLeadCaptureSchema = yup.object({
  firstName: yup.string().required('Please Provide your first name'),
  lastName: yup.string().required('Please Provide your last name'),
  email: yup.string().email().required('Please provide a valid email'),
  phone: yup.string().matches(phoneRegExp, 'Phone number is not valid'),
  tcAgree: yup.boolean().oneOf([true], 'Field must be checked'),
  updatesAgree: yup.boolean().oneOf([true], 'Field must be checked'),
});

export const SignUpSchema = yup.object({
  password: yup
    .string()
    .min(8, 'Password is too short - should be 8 chars minimum.')
    .required('Password is required'),
  passwordConfirmation: yup
    .string()
    .required('Please retype your password.')
    .oneOf([yup.ref('password')], 'Passwords must match'),
  firstName: yup.string().required('Please Provide your first name'),
  lastName: yup.string().required('Please Provide your last name'),
  email: yup.string().email().required('Please provide a valid email'),
  city: yup.string().required('Please provide the city are you based in'),
  tcAgree: yup.boolean().oneOf([true], 'Field must be checked'),
  updatesAgree: yup.boolean().oneOf([true], 'Field must be checked'),
  phoneNumber: yup.string().matches(phoneRegExp, 'Phone number is not valid'),
});

export const ArtistWaitListSchema = yup.object({
  prints: yup.boolean(),
  collectibles: yup.boolean(),
  stickers: yup.boolean(),
  apparel: yup.boolean(),
  sculptures: yup.boolean(),
  sculpture_budget: yup.number(),
  paintings: yup.boolean(),
  painting_budget: yup.number(),
});

export const ComboSignupAritstWaitListSchema =
  SignUpSchema.concat(ArtistWaitListSchema);
